import React, { useMemo } from 'react'
import { Box } from '@chakra-ui/react'

import { MarkdownRenderer } from '../../markdown-renderer'
import { QuestionFormItem } from '../form-types'

// inputs
import { RadioInput } from './radio.input'
import { FreetextInput } from './freetext.input'

interface QuestionSectionProps {
  section: QuestionFormItem;
  isDisabled?: boolean;
}

const QuestionSectionComponent: React.FC<QuestionSectionProps> = ({ section, isDisabled, ...rest }) => {
  const Input = useMemo(() => {
    switch (section.content.input.type) {
      case 'freetext':
        return FreetextInput
      case 'radio':
        return RadioInput
    }
  }, [section.content.input.type])

  return (
    <Box mb="medium" sx={{
      breakInside: 'avoid',
      position: 'relative',
      breakBefore: 'auto',
      breakAfter: 'auto',
    }} {...rest}>
      <Box mb="xsmall">
        <MarkdownRenderer>
          {section.content.markdown}
        </MarkdownRenderer>
      </Box>
      {/* @ts-ignore */}
      <Input input={section.content.input} id={section.id} isDisabled={isDisabled} />
    </Box>
  )
}

export const FormQuestionSection = React.memo(QuestionSectionComponent, (prevProps, nextProps) => prevProps.section.id === nextProps.section.id)